import {createApiClient, ApiClient, IHandlers} from '../services/ApiClient';
import { Session } from '../components/Utils';
import { RootState } from '../store';
import { findIndex, remove, isEmpty, isObject } from 'lodash';
import * as types from './ActionTypes';
import { history } from '../store';
import { MARK_ALL_VISITED, MARK_VISITED, SET_ERROR } from "./ActionTypes";
import { INITIAL_RULES } from "../const/forms";
import {confirmDialog} from 'primereact/confirmdialog';

let api = createApiClient();

export function getTypes(handlers: object) {
    return () => {
        api.getTypes(handlers)
    }
}

export function setRequest(data: any, handlers: object) {
    return (dispatch: any) => {
        dispatch({ type: types.SET_REQUEST, payload: data});
        const fields = [];
        // const sections = data.form ? data.form.sections.map(currentValue => {
        //     typeof currentValue !== 'undefined' && currentValue.controls.map(value => fields.push(value))
        // }) : [];
        if(data.request_meta && data.request_meta.sections.length > 0){
            dispatch({
                type: types.SET_SECTION, payload:
                  {
                      id: data.request_meta.sections[0].id
                  }
            });
        }

        const autoCompleteFields = fields.filter(field => field.extra && field.extra.init);
        initRules(dispatch, autoCompleteFields, data.values);
    }
}

export function createRequest(id: string, orn: string, handlers: object) {
    return (dispatch: any) => {
        dispatch({ type: types.LOADING_START, payload: 'form' });
        dispatch({ type: types.CLEAR_VALUES });
        return api.createRequest(id, orn, {
            success: response => dispatch(setRequest(response, handlers)),
            anyway: () => {
                dispatch({ type: types.LOADING_FINISH, payload: 'form' });
            }
        })
    }
}

export function getRequest(id: string) {
    if (id) {
        return (dispatch: any) => {
            dispatch({ type: types.LOADING_START, payload: 'form' });
            dispatch({ type: types.CLEAR_VALUES });
            return api.getRequest(id, {
                success: response => dispatch(setRequest(response, {
                    success: () => {}
                })),
                anyway: () => {
                    dispatch({ type: types.LOADING_FINISH, payload: 'form' });
                }
            })
        }
    }
}

export function deleteRequest(id: string) {
    if (id) {
        return (dispatch: any) => {
            confirmDialog({
                message: `Вы уверены, что хотите удалить заявку?`,
                header: 'Подтвердите действие',
                accept: () => {
                    dispatch({ type: types.LOADING_START, payload: 'requests' });
                    return api.deleteRequest(id, {
                        success: () => {
                            dispatch(getForms());
                        },
                        anyway: () => {
                            dispatch({ type: types.LOADING_FINISH, payload: 'requests' });
                        }
                    })
                },
                reject: () => {

                },
                acceptLabel: 'Да',
                rejectLabel: 'Нет',
            });
        }
    } else {
        return (dispatch: any) => dispatch(getForms());
    }
}

export function getProjects(orn) {
    return (dispatch: any) => {
        dispatch({type: types.LOADING_START, payload: 'projects'});
        api.getProjects(orn, {
            success: request => {
                dispatch({type: types.SET_PROJECTS, payload: request});
            },
            anyway: () => {
                dispatch({ type: types.LOADING_FINISH, payload: 'projects' });
            }
        })
    }
}

export function getForms() {
    return (dispatch: any, getState: any) => {
        const { orn } = getState().forms;
        if (!orn) {
            return;
        }
        dispatch({ type: types.LOADING_START, payload: 'requests' });
        api.getRequests(orn, {
            success: (response ) => {
                dispatch({ type: types.FETCH_FORMS, payload: response });
            },
            anyway: () => {
                dispatch({ type: types.LOADING_FINISH, payload: 'requests' });
            }
        })
    }
}

export function addValue(controlid:string, value:any, refresh: boolean){
    return (dispath: any, getState:() => RootState)=>{
        const state = getState().forms;
        const newValue = value;

        const api = createApiClient(state.form_type, state.process_id);

        if (!state.values) state.values = [];

        const result ={
            type: types.ADD_VALUE,
            payload: state.values || []
        };

        let idx = findIndex(state.values, (o:any) => o.controlid === controlid);

        if(idx > -1 && isEmpty(value)){ //delete
            result.payload = remove(state.values, (o:any) => o.controlid !== controlid);
            dispath(result);
        }else if(idx === -1 && isEmpty(value) === false){ //create
            const values = [...state.values,{ controlid, value }];
            dispath({ type: types.ADD_VALUE, payload: values });
        } else if (idx > -1 && isEmpty(value) === false){ //update
            if(isObject(newValue) || (!isObject(newValue) && state.values[idx].value != newValue)) {
                result.payload = [...state.values];
                if (result.payload[idx]) {
                    result.payload[idx].value = value;
                    dispath(result);
                }
            }
        }

        const values = getState().forms.values;
        if (!state['is_locked']) {
            api.saveRequest(state.id, values, {
                success: response => {
                    // console.log("SAVE RESPONSE", response);
                }
            });
        }
    }
}

export function setSection(id:string){
    return {
        type: types.SET_SECTION,
        payload: {
            id
        }
    }
}

export function sendRequest(id:string, data:any){
    return (dispatch: any) => {
        dispatch({ type: types.LOADING_START, payload: 'requests' });
        return api.sendDocument(id, data,{
            success: () => {
                dispatch(getForms());
            },
            anyway: () => {
                dispatch({ type: types.LOADING_FINISH, payload: 'requests' });
            }
        })
    }
}

export function clearValues(){
    return {
        type: types.CLEAR_VALUES,
        payload: {}
    }
}



export function requestUnchekUpdate(formId: any, valuesId: any){
    return {
        type: types.REQUEST_UNCHEK_UPDATE,
        payload:{
            formId,
            valuesId,
        }
    }
}

export function getNotify(form: any, values: any, handlers: object){
    return (dispatch: any) => {
        api.getNotify(form,values,handlers)
    }
}

export function createSession(uid: string, obj: Object){
    return (dispath: any) =>{
        api.createSession(uid,obj, {
            success: (response) =>{
                Session.setSession(response.id);

                dispath({type: types.CREATE_REQUEST_BEFORE, payload: null});
                dispath(fetchForm(uid,response.id));
                dispath(setFormUid(uid));
                dispath({type: types.SET_STATUS_DEFAULT, payload: 0})
            }
        })
    }
}

export function checkedPanel(panelId:string, checked:boolean, error: any | undefined){
    return (dispath: any) =>{
        dispath(setError(panelId, error));
        dispath(addValue(panelId, checked ? "1": null, false));
        dispath({
            type: types.CHECKED_PANEL,
            payload: {
                panelId,
                checked
            }
        })
    }
}

function initRules(dispatch: any, fields, values) {
    if (fields.length > 0) {
        let i = fields.length;

        while (i--) {
            if (typeof fields[i].extra.init !== 'undefined') {
                if (typeof INITIAL_RULES[fields[i].extra.init] !== 'undefined') {
                    INITIAL_RULES[fields[i].extra.init].callback(dispatch, values)
                }
            }
        }
    }
}

export function fetchValues(){
    return (dispath: any) =>{
        dispath(clearValues())
        dispath({ type: types.FETCH_FORM, payload :null })

        api.getAllValues({
            success: (response) =>{
                dispath({ type: types.FETCH_VALUES, payload: response})
            }
        })
    }
}

export function redirectInLK(url:string){
    return (dispath:any) =>{
        const api = createApiClient();
        api.redirect(url);
    }
}


export function setFormUid(uid: string){
    return {
        type: types.SET_FORM_UID,
        payload : uid
    }
}


export function copyForm(form_type:string, process_id: number) {
    return (dispatch:any) => {
        confirmDialog({
            message: `Копировать заявку?`,
            header: 'Подтвердите действие',
            accept: () => {
                api.copyForm(form_type, process_id, {
                    success: response => {
                        const { process_id, form_type } = response;
                        history.push(`/minigrants/forms/${form_type}/${process_id}`);
                        dispatch(getForms());
                    },
                    error: (error, response) =>{
                        alert("Не удалось скопировать заявку")
                    }
                })
            },
            reject: () => {

            },
            acceptLabel: 'Да',
            rejectLabel: 'Нет',
        });
    }
}

export function revokeForm(form_type:string, process_id: number) {
    return (dispatch:any) => {
        confirmDialog({
            message: `Отозвать отправленные документы?`,
            header: 'Подтвердите действие',
            accept: () => {
                api.revokeForm(form_type, process_id, {
                    success: () => {
                        dispatch(getForms());
                    },
                    error: (error, response) =>{
                        alert("Не удалось отозвать документы")
                    }
                })
            },
            reject: () => {

            },
            acceptLabel: 'Да',
            rejectLabel: 'Нет',
        });
    }
}

export function fetchForm(uid: string, values:number){
    return (dispath:any) => {

       dispath(clearValues());
       dispath({ type: types.FETCH_FORM, payload :null });

        var checkPanels = [];
        api.getFormByUid(uid,values,{
            success: (response) =>{
                dispath({ type: types.FETCH_FORM, payload : {...response, status:0 } });
                dispath(setSection(response.sections[0].id));

                history.push(`/create/${uid}/${Session.getSession()}`);
            }
        })
    }
}
export function addFile(controlid:string, value: any){
    return (dispath: any, getState:() => RootState)=>{
        const state = getState().forms;
        const result ={
            type: types.ADD_VALUE,
            payload: [...state.values ]
        };

        let idx = findIndex(state.values, (o:any) =>
                                            o.controlid === controlid)

        if(idx > -1 && isEmpty(value)){ //delete
            result.payload = remove(state.values, (o:any) => o.controlid !== controlid);
        }else if(idx === -1 && isEmpty(value) === false){ //create
            result.payload = [...state.values,{ controlid, value }];
        }
        else if (idx > -1 && isEmpty(value) === false){ //update
            result.payload = [...state.values];
            result.payload[idx].value = value;
        }

        dispath(result);
    }
}

function getControlsByType(form: any, type: string){
    const result = [];
    for(let section of form.sections){
        const control = section.controls.find(t => t.type === type);
        if(control){
            result.push(control);
        }
    }
    return result;
}

function checkRecal(schema: any, controlid: string): boolean {
    const controls: any = getControlsByType(schema, 'TotalHeader');
    if(controls.length > 0){
        const totalHeader = controls[0];
        for(let el of totalHeader.elements){
            if(controlid.indexOf(el as string) === 0){
                return true;
            }
          }
    }
    return false;
}

function recaleSumGrant(schema: any, values: any, dispath: any, api: ApiClient){}

function recalSumGrantDynamicGrid(schema: any, values: any, dispath: any, api: ApiClient){}

export function recal(){
    return  (dispath: any, getState:() => RootState)=>{
        const state = getState().forms;
        const api = createApiClient(state.form_type, state.process_id);

        recaleSumGrant(state.form, state.values, dispath, api);
        recalSumGrantDynamicGrid(state.form, state.values, dispath, api);
    }
}

export function incrimentToSend(){
    return (dispath: any, getState:() => RootState) =>{
        const state = getState().forms;

        dispath({ type: types.ATTEMPT_TO_SEND, payload: state.countToSend + 1});
    }
}



export function removeReportPdf(formId:string, values:string){
    return (dispath: any, getState:() => RootState) =>{
        const api = createApiClient();
        api.removeReportPdf(formId, values,{
            success: ()=>{
                dispath(fetchValues());
            }
        });
    }
}

export function copyValue(sourceId: string, targetId: string){
    return (dispath: any, getState:()=>RootState) =>{

        const { values, formUid } = getState().forms;
        const valueIdx = findIndex(values, (val:any) => val.controlid === sourceId);
        const api = createApiClient(formUid);

        if(valueIdx > -1){
            const value = values[valueIdx].value;
            if(isObject(value)){
                api.setValueSync(targetId, value, {
                    success: () =>{
                        dispath({ type: types.ADD_VALUE, payload: [...values,{ controlid: targetId, value }] });
                    }
                });
            }

        }
    }
}

export function markVisited(id: string) {
    return (dispatch: any, getState: () => RootState) => {
        dispatch({
            type: MARK_VISITED,
            payload: id
        });
    };
}

export function markAllVisited() {
    return (dispatch: any, getState: () => RootState) => {
        dispatch({
            type: MARK_ALL_VISITED,
        });
    };
}

export function setError(id: string, error: any) {
    return dispatch => {
        dispatch({
            type: SET_ERROR,
            payload: {
                id,
                error
            }
        });
    };
}
